import api from "@/plugins/api/EntryPoint";

export default {
  async getIndications(params, callBackFn) {
    await api.post(`history/indication`, params, callBackFn);
  },
};
